import * as React from 'react';
import {useEffect, useState} from 'react';
import './list-nominations.scss'
import {ListItem} from "../list-item/index";
import {Nomination} from '../list-item/index';
import {CategoryData} from "../../../enums/categories";
import {getVotesCategoryStore, updateVotesStore} from '../../../actions/vote-store';
import {setError} from "../../errors";
import arrow from "../../../images/arrow-down.png";

type Props = {
	nominations: Array<Nomination>,
	currentCategory: number
	setCategory: (category: number) => void
	setShow: Function
	setAlertServiceValues: Function
};

export const ListNominations = (
	{
		nominations,
		setCategory,
		currentCategory,
		setShow,
		setAlertServiceValues
	}: Props) => {
	
	const [categoryVotes, setCategoryVotes] = useState([]);
	const [isDisabled, setIsDisabled] = useState(false);
	const [scrollHelpHidden, setScrollHelpHidden] = useState(false);
	const [currentTarget, setCurrentTarget] = useState(null);

	useEffect(() => {
		const votesOnCategory = getVotesCategoryStore(currentCategory)
		if (typeof votesOnCategory !== "undefined" && votesOnCategory.length > 0) {
			setCategoryVotes(votesOnCategory)
			setVote(0)
		}
	}, [setCategoryVotes, currentCategory, getVotesCategoryStore])
	
	const renderNominations = () => {
		if (nominations) {
			return nominations.map((nomination, i) => {
				return <ListItem
					nomination={nomination}
					category={currentCategory}
					key={i}
					setCurrentTarget={setCurrentTarget}
					onChange={setVote}
					disabled={(isDisabled && !categoryVotes.includes(`${nomination.Id}`))}/>
			})
		}
	}
	
	const setVote = (e: number) => {
		let updatedCategoryVotes = categoryVotes;
		if (categoryVotes.includes(e)) {
			updatedCategoryVotes = categoryVotes.filter(c => c !== e)
		} else {
			updatedCategoryVotes.push(e)
		}
		if (updatedCategoryVotes.length >= 5) {
			setIsDisabled(true);
			document.getElementsByClassName('next-category')[0].scrollIntoView({behavior: "smooth"});
		} else {
			setIsDisabled(false)
		}
		setCategoryVotes(updatedCategoryVotes);
	}
	
	const nextCategory = () => {
		if (currentCategory === 0) {
			setCategory(currentCategory + 1)
			return;
		}
		// занулява само ако са вотнати достатъчно от категория
		if (categoryVotes.length < 5) {
			setError(`Трябва да изберете още ${5 - categoryVotes.length} от тази категория.`, setShow, setAlertServiceValues)
		} else {
			// vote({vote: categoryVotes, category: currentCategory});
			if(window.audioItem && !window.audioItem.paused) {
				currentTarget.click()
			}
			setIsDisabled(false);
			setCategoryVotes([]);
			setCategory(currentCategory + 1);
			document.getElementsByClassName('position-top')[0].scrollIntoView({behavior: "smooth"});
		}
		updateVotesStore({[currentCategory]: categoryVotes});
	}

	const hideScrollHelp = (e: any) => {
		if (!scrollHelpHidden) {
			setScrollHelpHidden(true);
		}
	}
	
	return (
		<div className='nominations'>
			<h1 className="category-name">{Object.values(CategoryData)[currentCategory].title}</h1>
			<div id="cat-list-wrap" className={`category-list`} onScroll={hideScrollHelp}>
				<div className="category-list-inner-wrap">
					{renderNominations()}
				</div>
			</div>
			<div className="next-category">
				<button className="btn btn-dark" onClick={nextCategory}>Напред →</button>
			</div>
		</div>
	);
};
